/** ISO-8601 week info (Monday-based, week 1 contains the year's first Thursday). */
export function getIsoWeekInfo(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7; // Monday=1 .. Sunday=7
  const monday = new Date(d);
  monday.setUTCDate(d.getUTCDate() - (dayNum - 1));

  d.setUTCDate(d.getUTCDate() + 4 - dayNum); // nearest Thursday
  const isoYear = d.getUTCFullYear();
  const yearStart = new Date(Date.UTC(isoYear, 0, 1));
  const isoWeek = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);

  const sunday = new Date(monday);
  sunday.setUTCDate(monday.getUTCDate() + 6);

  return { isoYear, isoWeek, monday, sunday };
}

/** Builds the periodKey in the same format used by RankingServiceImpl on the backend. */
export function getPeriodKey(type, date) {
  if (type === 'WEEKLY') {
    const { isoYear, isoWeek } = getIsoWeekInfo(date);
    return `${isoYear}-W${String(isoWeek).padStart(2, '0')}`;
  }
  if (type === 'MONTHLY') {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
  }
  return String(date.getFullYear());
}

/** Returns a new reference date shifted `offset` whole periods into the past. */
export function shiftDate(date, type, offset) {
  const d = new Date(date);
  if (type === 'WEEKLY') {
    d.setDate(d.getDate() - offset * 7);
  } else if (type === 'MONTHLY') {
    d.setMonth(d.getMonth() - offset);
  } else {
    d.setFullYear(d.getFullYear() - offset);
  }
  return d;
}

/** Natural calendar range (start/end) that the given date falls into. */
export function getPeriodRange(type, date) {
  if (type === 'WEEKLY') {
    const { monday, sunday } = getIsoWeekInfo(date);
    return { start: monday, end: sunday };
  }
  if (type === 'MONTHLY') {
    const start = new Date(date.getFullYear(), date.getMonth(), 1);
    const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return { start, end };
  }
  const start = new Date(date.getFullYear(), 0, 1);
  const end = new Date(date.getFullYear(), 11, 31);
  return { start, end };
}

/** Localized label describing the natural period the given date belongs to. */
export function formatPeriodLabel(type, date, locale) {
  if (type === 'MONTHLY') {
    return date.toLocaleDateString(locale, { month: 'long', year: 'numeric' });
  }
  if (type === 'YEARLY') {
    return String(date.getFullYear());
  }

  const { start, end } = getPeriodRange(type, date);
  const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
  const startStr = start.toLocaleDateString(locale, sameMonth ? { day: 'numeric' } : { day: 'numeric', month: 'short' });
  const endStr = end.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
  return `${startStr} - ${endStr}`;
}
